var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInputCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00008 7.41429L10.293 11.7072L11.7072 10.293L7.41429 6.00008L11.7072 1.70718L10.293 0.292969L6.00008 4.58586L1.70718 0.292969L0.292969 1.70718L4.58586 6.00008L0.292971 10.293L1.70718 11.7072L6.00008 7.41429Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInputCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/input-cross.0934274a.svg";
export { ForwardRef as ReactComponent };